import { styled } from 'styled-components'
import { THUMBNAIL_RENDER_SIZE_PX } from './consts'

export const Container = styled.div`
  width: ${THUMBNAIL_RENDER_SIZE_PX}px;
  height: ${THUMBNAIL_RENDER_SIZE_PX}px;
  flex-shrink: 0;
  position: relative;
  overflow: visible;
`

export const FallbackIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`
